import {EMPTY_CELL_PLACEHOLDER} from '../constants/cellPlaceholder';

/**
 * Returns a renderable string for a text-like cell value, returning the
 * empty-cell placeholder (empty string by default, '–' en dash in DASH mode) for
 * nil / empty / whitespace-only values. `0` and other meaningful falsy
 * strings pass through unchanged.
 */
export const getDisplayValue = (
  value: string | null | undefined,
  emptyCellValue: string = EMPTY_CELL_PLACEHOLDER
): string => {
  if (value == null || value.trim() === '') {
    return emptyCellValue;
  }
  return value;
};
